(function (module) {
    'use strict';

    function appPreviewCtrl($scope, $element, $timeout, Store) {
        this.$onInit = () => {
            this.loaded = false;
            this.iframe = null;
            this.showMuteLabel = this.slug === 'youtube';

            // initial
            $scope.$watchGroup(['$ctrl.type', '$ctrl.data', '$ctrl.settings', '$ctrl.cache'], ([type, data, settings, cache]) => {
                if (!this.loaded && type && data && settings && cache) this.sendInitial(type, data, settings, cache);
            }, true);

            // data changes
            $scope.$watch('$ctrl.data', (data) => {
                if (this.loaded && data) {
                    if (this.slug === 'gallery-slider') {
                        const allFiles = Store.getFiles();
                        const files = _(data.files).map((file) => {
                            if (file.id) return file;
                            return {
                                id: file,
                            };
                        })
                            .map(({ id, displayTime }) => {
                                const f = allFiles.find(file => file.id === id);
                                if (!f) return;
                                const { original: url, contentType } = f;
                                return { url, contentType, displayTime };
                            })
                            .compact()
                            .value();
                        this.postMessage('preview', files);
                    } else {
                        this.postMessage('static', { data });
                    }
                }
            }, true);

            $scope.$watch('$ctrl.settings', (settings) => {
                if (this.loaded && settings) this.postMessage('static', { settings });
            }, true);

            $scope.$watch('$ctrl.dynamic', (dynamic) => {
                if (dynamic && (this.loaded || this.slug.endsWith('-news'))) {
                    this.postMessage('preview', dynamic);
                }
            }, true);
        };

        this.sendInitial = (type, data, settings, cache, events) => {
            switch (type) {

                // for app type integration we need initial cache
                case 'integration' : {
                    if (data && settings && cache) {
                        this.postMessage('initial', { data, settings, cache });
                    }
                    break;
                }

                // for app type standard we need just need data & settings - no cache here
                case 'standard': {
                    if (data && settings) this.postMessage('initial', { data, settings });
                    break;
                }

                // for app type custom we need just need data & settings - no cache here
                case 'custom': {
                    const EVENTS = (events && events.length) ? events : [];
                    if (data || settings) this.postMessage('initial', {
                        data, settings, events: JSON.parse(angular.toJson(EVENTS)),
                    });
                    break;
                }

                // iframe just needs the URL
                case 'iframe': {
                    if (data && data.url || data && data.urls) {
                        $timeout(() => {
                            this.loaded = true;
                        });
                    }
                    break;
                }
            }
        };

        this.postMessage = (messageType, messageBody) => {
            if (this.iframe && this.iframe.contentWindow) {
                $timeout(() => {
                    // switching loaded to true here will prevent flickering
                    // as we will show app only once we sent first message
                    this.loaded = true;
                    this.iframe.contentWindow && this.iframe.contentWindow.postMessage({
                        messageType,
                        messageBody,
                    }, '*');
                }, 500);
            }
        };

        this.onFrameLoaded = () => {
            this.iframe = $element.find('iframe')[0];
            $timeout(() => {
                this.loaded = true;
                this.sendInitial(this.type, this.data, this.settings, this.cache, this.events);
                if (this.dynamic) this.postMessage('preview', this.dynamic);
            }, 500);
        };
    }

    module
        .component('appPreview', {
            template: '<iframe allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" style="background: white" ng-show="$ctrl.loaded" ng-frame on-frame-loaded="$ctrl.onFrameLoaded()" ng-src="{{ $ctrl.src | trustUrl }}" frameborder="0" scrolling="auto"></iframe><span ng-show="$ctrl.showMuteLabel && $ctrl.loaded">Click on preview to pause/start video</span>',
            controller: appPreviewCtrl,
            bindings: {
                type: '<',
                src: '<',
                data: '<',
                settings: '<',
                events: '<',
                cache: '<',
                dynamic: '<',
                slug: '<',
                realm: '<',
            },
        });

})(angular.module('rocket.components'));
